import React from 'react';
import {Button, Dialog, DialogActions, DialogContent, DialogTitle, LinearProgress} from "material-ui";
import {RegulationResultForm} from "../../../forms/regulation_result";
import {connect} from "react-redux";
import {
    clearRegulationResultError,
    closeCreateRegulationResultsFetch,
    closeUpdateRegulationResultsFetch,
    createRegulationResult,
    updateRegulationResult
} from "../../../redux/actions/regulation_results";
import {snackMessageShow} from "../../../redux/actions/snack_message";

export class RegulationResultDialog extends React.Component {

    componentDidMount = () => {
        this.props.initialize();
    };

    handleClose = () => {
        this.props.handleClose();
        setTimeout(() => {
            this.props.initialize();
        }, 10);
    };

    handleSubmit = (values) => {
        if (this.props.regulation_result.id === undefined) {
            this.props.createRegulationResult({
                ...values
            }, this.props.activeCompanyId, this.handleClose);
        } else {
            this.props.updateRegulationResult(values, this.handleClose);
        }
    };

    onClickSubmit = () => {
        this.refs.regulationResultFrom.submit();
    };

    render() {

        const {open, regulation_result, errors, isCreateRegulationResultFetch, isUpdateRegulationResultFetch} = this.props;

        return (
            <Dialog
                open={open}>

                <DialogTitle id="form-dialog-title">ステータス更新</DialogTitle>

                <DialogContent>
                    <RegulationResultForm
                        errors={errors}
                        onSubmit={this.handleSubmit}
                        ref="regulationResultFrom"
                        initialValues={regulation_result}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.handleClose} color="default"
                            disabled={isCreateRegulationResultFetch || isUpdateRegulationResultFetch}>
                        キャンセル
                    </Button>

                    {regulation_result.id === undefined ?
                        <Button onClick={this.onClickSubmit} color="primary" disabled={isCreateRegulationResultFetch}>
                            アップデート
                        </Button>
                        : null}

                    {regulation_result.id !== undefined ?
                        <Button onClick={this.onClickSubmit} color="primary" disabled={isUpdateRegulationResultFetch}>
                            アップデート
                        </Button>
                        : null}

                </DialogActions>
                {isCreateRegulationResultFetch || isUpdateRegulationResultFetch ? <LinearProgress/> : null}
            </Dialog>
        )
    }
}

RegulationResultDialog = connect(
    (state) => {
        return {
            activeCompanyId: state.app.activeCompanyId,
            regulation_result: state.regulation_results.regulation_result,
            errors: state.regulation_results.errors,
            isCreateRegulationResultFetch: state.regulation_results.isCreateRegulationResultFetch,
            isUpdateRegulationResultFetch: state.regulation_results.isUpdateRegulationResultFetch,
        }
    },
    (dispatch) => {
        return {
            initialize: () => {
                dispatch(clearRegulationResultError());
            },
            createRegulationResult: (result, companyId, callback) => {
                dispatch(createRegulationResult(result, companyId)).then((response) => {
                    setTimeout(() => {
                        dispatch(closeCreateRegulationResultsFetch());
                        switch (response.type) {
                            case 'API_CREATE_REGULATION_RESULT_FAIL':
                                dispatch(snackMessageShow('ステータスの更新に失敗しました'));
                                break;
                            default:
                                dispatch(snackMessageShow('ステータスを更新しました'));
                                callback();
                        }
                    }, 300);

                });
            },
            updateRegulationResult: (result, callback) => {
                dispatch(updateRegulationResult(result)).then((response) => {
                    setTimeout(() => {
                        dispatch(closeUpdateRegulationResultsFetch());
                        switch (response.type) {
                            case 'API_UPDATE_REGULATION_RESULT_FAIL':
                                dispatch(snackMessageShow('ステータスの更新に失敗しました'));
                                break;
                            default:
                                dispatch(snackMessageShow('ステータスを更新しました'));
                                callback();
                        }
                    }, 300);

                });
            },
        }
    }
)(RegulationResultDialog);


// WEBPACK FOOTER //
// ./src/containers/regulation/dialog/result.js